import { Progress } from "../../components/progress/Progress";
import { useEffect, useRef, useState } from "react";
import { Spiner } from "../../components/spinner/Spiner";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { RequestMethodModal } from "./RequestMethodModal";
import Button, { BtnProps } from "../../components/button/Button";
import companiesQuery from "../../firestore/Companies.query";
import { auth, appStorage } from "../../firebase";
import { UserCardCreateState, userCardTimestampToDate } from "../../model/Systemparameters";
import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";
import { getDownloadURL, ref, uploadBytes, deleteObject, getBlob } from "firebase/storage";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { Company, initialCompany } from "../../model/Companies";
import ExcelJS, { CellRichTextValue } from "exceljs";
import { convertDateTimeToString, convertDateTimeToJapaneseString, convertDateTimeToStringCompactFormat, convertDateSecToStringCompactFormat} from "../../utility/ConvertUtily";
import { ModalAndAlmightyDialog } from "../../components/modal/ModalAndAlmightyDialog";
import userQuery from "../../firestore/User.query";
import { User } from "../../model/Users";
import systemParametersQuery from "../../firestore/SystemParameters.query";
import { UserIdcardFileDeleteModal } from "./UserIdcardFileDeleteModal";
import { UserIdcardFileApplicationModal } from "./UserIdcardFileApplicationModal";
import { ConstMessage } from "../../config/const";
import { MaxApplicationCountModal } from "./MaxApplicationCountModal";
import { UserIdCardErrorInfoModal } from "./UserIdCardErrorInfoModal";
import authApi from "../../api/Auth.api";
import { getImportErrorFileNamePrefix } from "../../utility/CommonUtility";
import { checkOption } from "../../controller/OptionController";

export const UsersIdcardCreate = () => {
  // ログイン中の団体情報
  const currentUser = auth.currentUser;
  const tenantId = currentUser?.tenantId;

  const dispatch = useDispatch();
  const [loadProgress, setLoadProgress] = useState<number>(-1);
  const [isLoad, setIsLoad] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [targetFile, setTargetFile] = useState<File>();
  const [monthlyApplicationCount, setApplicationCount] = useState(0); 
  const [userCardCreateStateList, setUserCardCreateStateList] = useState<UserCardCreateState[]>([]);
  const [dialogChildren, setDialogChildren] = useState<React.ReactNode | undefined>();
  const [dialogTitle, setDialogTitle] = useState<string>('');
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [dialogActions, setDialogActions] = useState<BtnProps[]>([]);
  const [company, setCompany] = useState<Company>(initialCompany);
  const [isImport, setIsImport] = useState(false);
  const [deleteDialogIsOpen, setDeleteDialogIsOpen] = useState(false);
  const [fileDataInfo, setFileDataInfo] = useState<any[]>([]);
  const [selectFile, setSelectFile] = useState<UserCardCreateState | undefined>();
  const [applicationFile, setApplicationFile] = useState<UserCardCreateState | undefined>();
  const [applicationDialogIsOpen, setApplicationDialogIsOpen] = useState(false);
  const [fileName, setFileName] = useState<string>('');
  const [maxApplicationCountIsOpen, setMaxApplicationCountIsOpen] = useState(false);
  const [detailFlg, setDetailFlg] = useState(false);
  const [isOpenErrorInfoDialog, setIsOpenErrorInfoDialog] = useState(false);
  const [updateFlg, setUpdateFlg] = useState(false);
  const [maxApplicationCount, setMaxApplicationCount] = useState(0);
  const [maxApplicationSheet, setMaxApplicationSheet] = useState(0);
  const [requestLimitFlg, setRequestLimitFlg] = useState(false);

  const fileAttached = "申請書添付";
  const fileInputRef = useRef<HTMLInputElement>(null);

  // 依頼方法モーダルの開閉トリガー
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const f = async () => {
      try {
        // 団体情報の取得
        const company = await companiesQuery.getCompany(tenantId!);
        setCompany(company);

        // 申請添付済みファイル一覧取得
        const userCardCreateStateList = await systemParametersQuery.getUserCardCreateState(company.id) as UserCardCreateState[];
        setUserCardCreateStateList(userCardCreateStateList);

        //今月の申請回数
        const nowDate = new Date();
        let userIdCardCreatListResult: UserCardCreateState[] = [];
        userCardCreateStateList.map((item) => {
          userIdCardCreatListResult.push(userCardTimestampToDate(item));
        });
        const monthlyApplicationList = userIdCardCreatListResult.filter((userIdCardeNewList: { requestAt?: Date | null;}) => 
          userIdCardeNewList.requestAt? 
          userIdCardeNewList.requestAt >= new Date(nowDate.getFullYear(), nowDate.getMonth()) && 
          userIdCardeNewList.requestAt < new Date(nowDate.getFullYear(), nowDate.getMonth()+1) 
          : 0
        );
        setApplicationCount(monthlyApplicationList.length);
      } catch (err: any) {
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          dispatch(alertOpen(AlertValue("失敗しました。", "danger")));
        }
      }
      // 申請枚数の制限の有無を取得
      const userIdCardRequestLimitFlg = await systemParametersQuery.getUserIdCardRequestLimitFlg();
      setRequestLimitFlg(userIdCardRequestLimitFlg);
      // 申請回数の制限数を取得
      const userIdCardMaxRequestCount = await systemParametersQuery.getUserIdCardMaxRequestCount();
      setMaxApplicationCount(userIdCardMaxRequestCount);
      // 申請枚数の制限数を取得
      const userIdCardMaxRequestSheet = await systemParametersQuery.getUserIdCardMaxRequestSheet();
      setMaxApplicationSheet(userIdCardMaxRequestSheet);
      setIsLoad(false);
    }
    f();
  }, [dispatch, updateFlg]);

  // アップロード完了ダイアログ用プロパティ
  useEffect(() => {
    if (loadProgress >= 100 && isImport) {
      const failedCnt = fileDataInfo.filter((item) => item.status === "failed").length;
      if (failedCnt === 0) {
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "閉じる",
            onClick: () => {
              setIsOpenDialog(false);
            }
          },
        ];
        const childText = (<>
          <div><p>{ConstMessage.IMPORT_EXCEL_SUCCESS_DIALOG_TEXT}</p></div>
          <ul className={`m-2 text-green-700`}>
            <li className={"flex"}><DocumentArrowUpIcon className={"h-6 w-6"} />{fileName}</li>
          </ul>
        </>)

        setIsImport(false);
        setIsOpenDialog(true);
        setDialogTitle(fileAttached);
        setDialogChildren(childText);
        setDialogActions(actions);
        setLoadProgress(100);
      } else {
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "ファイルのダウンロード",
            onClick: () => {
              setIsOpenDialog(false);
              setProgress(0);
              downloadErrorFile().then(() => {
                setProgress(100);
                setTargetFile(undefined);
                setFileDataInfo([]);
              });
            }
          },
        ];
        const childText = (<>
          <div><p>{ConstMessage.IMPORT_EXCEL_FAILED_DIALOG_TEXT}</p></div>
          <ul className={`m-2 text-green-700`}>
            <li className={"flex"}><DocumentArrowUpIcon className={"h-6 w-6"} />{fileName}</li>
          </ul>
          <div className={'text-red-500'}><p>{ConstMessage.IMPORT_FAILED_USER_NUMBER_DIALOG_TEXT}</p></div>
          <div className={'text-red-500'}><p>{ConstMessage.IMPORT_APPLOAD_FAILED_DIALOG_TEXT_WORNING}</p></div>
        </>);
        setIsImport(false);
        setIsOpenDialog(true);
        setDialogTitle(fileAttached);
        setDialogChildren(childText);
        setDialogActions(actions);
        setLoadProgress(100);
      }
    }
  }, [loadProgress, isImport, fileDataInfo]);

  // プログレスバー
  const setProgress = (progress: number) => {
    setLoadProgress(progress);
  }

  // 申請書ダウンロード
  const onAplicationFileDownload = async () => {
    const messageFileName = `利用者IDカード発行申請書.xlsx`;
    const filePath = ref(appStorage, `format/UsersIdcardCreate/${messageFileName}`);
    const excelblob = await getBlob(filePath);
    const blobURL = window.URL.createObjectURL(excelblob as Blob);
    const promise = new Promise<any>(() => {
      const xhr = new XMLHttpRequest();
      setLoadProgress((0));
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try {
          setLoadProgress(Math.round(1 / 3 * 100));
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          setLoadProgress(Math.round(2 / 3 * 100));
          worksheet.pageSetup = {orientation:'portrait'};
          //団体名を入力
          worksheet.getCell(`B1`).value = company.displayId;
          
          const uint8Array = await workbook.xlsx.writeBuffer();
          const blob = new Blob([uint8Array], { type: "application/octet-binary" });
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob);
          link.download = `利用者IDカード発行申請書_${company.name}.xlsx`;
          document.body.appendChild(link)
          setLoadProgress(100);
          dispatch(alertOpen(AlertValue("ダウンロードに成功しました。", "success")));
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        } catch (err: any) {
          console.log(err);
          dispatch(alertOpen(AlertValue("ダウンロードに失敗しました。", "danger")));
        }
      }
      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);  
    });
    return promise;
  }

  // 注釈設定
  const annotation = [
    ["※上記団体番号は変更できません。"], // 2行目
    ["※利用者IDカードを出力したい利用者の番号を「利用者番号」下に記載してください。"], // 3行目
  ];

  // 項目名
  const column = [
    { header: "利用者番号", key: "userNumber" },
  ];

  // セルの値を取得
  function getCellText(cellValue: any) {
    const cellRichText = cellValue as CellRichTextValue;
    let cellText;
    if (cellValue === null) {
      cellText = ''
    } else {
      cellText = cellRichText.toString() ?? '';
    }
    return cellText;
  }

  const columns: GridCol[] = [
    { field: "number", headerName: "No.", style: "w-1/12", sort: false },
    { field: "dispFileName", headerName: "ファイル名", style: "w-3/12", sort: false },
    { field: "status", headerName: "ステータス", style: "w-1/12", sort: false },
    { field: "createCount", headerName: "カード数", style: "text-right", sort: false },
    { field: "requestAt", headerName: "申請日", style: "w-2/12", sort: false },
    { field: "createAt", headerName: "出力日", style: "w-2/12", sort: false },
    { field: "exportButton", headerName: "", style: "w-1/12", sort: false },
    { field: "subExportButton", headerName: "", style: "w-1/12", sort: false },
  ];

  const sortList = () => {
    return userCardCreateStateList.sort((a, b) => {
      const currentRowData = a.attachmentAt;
      const previewRowData = b.attachmentAt;
      if(currentRowData === previewRowData) {
        return 0;
      }
      return currentRowData < previewRowData  ? 1 : -1;
    });
  }

  const rowList: GridRow[] = sortList().map<GridRow>((item, i) => {
    let displayStatus = "";
    let exportButton = (<></>);
    let subExportButton = (<></>);
    switch (item.status) {
      case 'waitRequest':
        displayStatus = '申請待ち';
        exportButton = (
          <div className={'flex space-x-1'}>
          <Button
            size={'md'}
            children={"申請"}
            className={"whitespace-nowrap"}
            onClick={async () => {
              if (await checkOption("userIdCard", dispatch)) {
                //申請回数が上限を超えた場合
                if(monthlyApplicationCount >= maxApplicationCount){
                  MaxApplicationCountToggle();
                } else {
                  ApplicationDialogToggle();
                  setApplicationFile(item);
                }
              }
            }}
          />
          <Button
            color={'red'}
            size={'md'}
            children={"削除"}
            className={"whitespace-nowrap"}
            onClick={async () => {
              if (await checkOption("userIdCard", dispatch)) {
                deleteDialogToggle();
                setSelectFile(item);
              }
            }}
          />
          </div>
        )
        break;

      case 'standBy':
        displayStatus = '申請中';
        break;
      case 'inOperation':
        displayStatus = '出力中';
        break;
      case 'completion':
        displayStatus = '出力完了';
        exportButton = (
          <Button
            size={'md'}
            children={"ダウンロード"}
            className={"md:px-9 whitespace-nowrap"}
            onClick={async () => {
              if (await checkOption("userIdCard", dispatch)) {
                onDownloadPDF(item);
                }
              }
            }
          />
         ) 
        {
          item.errorUserMaps && item.errorUserMaps.length > 0 ? (
            subExportButton = ( 
              <Button
                outline
                size={'md'}
                children={"詳細"}
                className={"whitespace-nowrap"}
                onClick={async () => {
                  if (await checkOption("userIdCard", dispatch)) {
                    setDetailFlg(false);
                    setSelectFile(item);
                    toggleErrorInfoDialog();
                    }
                  }
                }
              />
            ) 
          ) : (
            <></>
          )
        }
        break;
      case 'impossible':
        displayStatus = '出力不可';
        subExportButton = (
          <Button
            outline
            size={'md'}
            children={"詳細"}
            className={"whitespace-nowrap"}
            onClick={() => {
              setDetailFlg(false);
              setSelectFile(item);
              toggleErrorInfoDialog();
            }
            }
          />
        )
        break;
    }
    const requestAtData = item.requestAt as any;
    const createAtData = item.createAt as any;
    const pdfFileNames = item.pdfFileName as any;
    const dispExcelFileNames = item.dispExcelFileName as any; 
    const createCount = item.createCount as any;
    return {
      rowData: {
        number: i + 1,
        dispFileName: (
          item.status == 'completion'?
          <div style={{ whiteSpace: "pre-line" }}>
            {pdfFileNames}
          </div>
          :
          <div style={{ whiteSpace: "pre-line" }}>
            {dispExcelFileNames}
          </div>
        ),
        status: displayStatus,
        createCount: createCount,
        requestAt: requestAtData ? convertDateTimeToString(new Date(requestAtData)) : "",
        createAt: createAtData ? convertDateTimeToString(new Date(createAtData.seconds * 1000)) : "",
        exportButton: exportButton,
        subExportButton: subExportButton
      }
    };
  });

    // 詳細ボタン押下時の一覧表示
    const userIdCardErrorCol: GridCol[] = [
      {
        field: "id",
        headerName: "利用者番号",
        style: ""
      },
      {
        field: "name",
        headerName: "名前",
        style: "white-space: pre-line"
      },
      {
        field: "message",
        headerName: "理由",
        style: "white-space: pre-line"
      },
    ];

     const userIdCardErrorRow: GridRow[] = (selectFile?.errorUserMaps?? []).map<GridRow>((error) => {
      return {
        rowData: {
          id: error.userId,
          name: error.userName,
          message: (
            <>
            {error.message.map((item) => {
              return(
                <div style={{whiteSpace: "pre-line"}}>
                  {item}
              </div>
              )
            })}
          </>
          ),
        }
      }
    });

  //削除モーダルの開閉トリガー
  const deleteDialogToggle = () => {
    setDeleteDialogIsOpen(!deleteDialogIsOpen);
  };

  //申請モーダルの開閉トリガー
  const ApplicationDialogToggle = () => {
    setApplicationDialogIsOpen(!applicationDialogIsOpen);
  };
  const MaxApplicationCountToggle = () => {
    setMaxApplicationCountIsOpen(!maxApplicationCountIsOpen);
  };

  // 詳細ダイアログの開閉
  const toggleErrorInfoDialog = () => {
    setIsOpenErrorInfoDialog(!isOpenErrorInfoDialog);
  };

  //申請書添付
  const onImport = async (
    format: 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setLoadProgress(0);
    const importAllWorningMessage = (
      <div className={'text-red-500'}>
        <p className="mt-3 mb-1">※Excel取込は、ID数によって<span className={"font-bold text-red-700"}>作業時間が長時間になる場合があります。</span></p>
        <p className="mb-5">※一度実行すると中止することはできません。</p>
      </div>
      );
    if (file != null) {
      setFileName(file.name);
    }

    checkImport(format, file, e).then((res) => {
      // インポート前確認ダイアログ
      const actions: BtnProps[] = [
        {
          outline: true,
          children: "キャンセル",
          className:"w-[132px]",
          onClick: () => {
            e.target.value = '';
            setIsOpenDialog(false);
            initDialog();
          }
        },
        {
          color: "indigo",
          children: "OK",
          disabled: res ?? '',
          className: "w-[132px]",
          onClick: () => {
            e.target.value = '';
            importMessage(format, file, e);
            setIsOpenDialog(false);
            initDialog();
          }
        },
      ];

      const importErrorMessage = (
        <div className={'text-red-500'}>
          {res !== null ? (<>{res}</>) : (<></>)}
        </div>);

      const dialogChildren = (<>
        Excelファイルをアップロードします。
        <ul className={`list-disc m-2 text-${format === 'xlsx' ? 'green' : 'yellow'}-700`}>
          {
            (<li className={"flex"}><DocumentArrowUpIcon className={"h-6 w-6"} />{file?.name}</li>)
          }
        </ul>
        {res !== null ? "" : importAllWorningMessage}
        {res !== null ? importErrorMessage : ""}
      </>)
      setIsOpenDialog(true);
      setDialogTitle(fileAttached);
      setDialogChildren(dialogChildren);
      setDialogActions(actions);
    });
  };

  // カラムの存在チェック
  const getTargetCol = (targetCol: ExcelJS.Row, targetColName: String) => {
    for (let i = 1; i <= targetCol.cellCount; i++) {
      const targetColValue = targetCol.getCell(i).value?.toString() ?? '';
      if (targetColName === targetColValue) {
        return i;
      }
    };
    return -1;
  }

  // アップロード前ファイルチェック
  const checkImport = async (
    format: 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoadProgress((0));
    const blobURL = window.URL.createObjectURL(file as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = async () => {
        setLoadProgress(Math.round(1 / 3 * 100));
        const result = xhr.response;
        const data = new Uint8Array(result);
        try {
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          worksheet.pageSetup = { orientation: 'portrait' };
          //ファイル形式チェック
          setLoadProgress(Math.round(2 / 3 * 100));
          const tenantHeader = "団体番号";
          const tenantCellText = worksheet.getCell("A1");
          const columnHeader = "利用者番号";
          const headerCellText = worksheet.getCell("A5");
          if(tenantHeader != (tenantCellText.toString() ?? '') || columnHeader != (headerCellText.toString() ?? '')){
            throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
          }
          // ファイル内の団体番号と実行者の団体番号を比較
          const tenantNo = company.displayId;
          const tenantNoRow = worksheet.getRow(1);
          if(tenantNo !== (tenantNoRow.getCell(2).value?.toString() ?? '')){
            throw new Error(ConstMessage.ERR_TENANT_NO);
          }
          const headerRowNum = annotation.length + 3;
          const checkedCellHeader = worksheet.getRow(headerRowNum);
          const startRow = headerRowNum + 1;
          const checkedCol = getTargetCol(checkedCellHeader, '利用者番号');
          const targetRowCnt = checkedCol >= 0 ?
          worksheet.rowCount + 1 - startRow - worksheet.getColumn(checkedCol).values.filter((value) => value === "").length :
          worksheet.rowCount + 1 - startRow;
          if(targetRowCnt == 0){
            throw new Error(ConstMessage.ERR_NONE_INPUT_ID);
          }
          setProgress((100));
          resolve(null);
        } catch (e: any) {
          console.error(e);
          setLoadProgress(-1);
          if(e.message == ConstMessage.ERR_NONE_INPUT_ID){
            resolve(e.message);
          } else {
            resolve(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
          }
        }
      };
      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);
    });
    return promise;
  }

  const importMessage = async (
    format: 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    importData(format, file).then(async (res) => {
      setFileDataInfo(res.data);
      e.target.value = '';
      if (res.status == "failed") {
        // １件でもインポートに失敗した場合
        let errorList: string[] = [];
        res.data.map((item: any, index: number) => {
          if (item.status == "error") {
            errorList.push(String(index + 1) + "行目");
          }
        });
        if (errorList.length > 0) {
          dispatch(alertOpen(AlertValue(errorList.join(",") + "のインポートに失敗しました。", "danger")));
        }
      }
    });
  };

  //現在の年月を取得(yymm)
  function getCurrentMonth() {
    var dt = new Date();
    var y = dt.getFullYear();
    var m = ("00" + (dt.getMonth() + 1)).slice(-2);
    var result = y + m;
    var currentMonth = result.substring(2);
    return currentMonth;
  }

  // 入力処理
  const importData = async (
    format: 'xlsx',
    file: File | null,
  ) => {
    setLoadProgress(0);
    setIsImport(true);
    const blobURL = window.URL.createObjectURL(file as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try {
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          worksheet.columns = column;
          worksheet.pageSetup = { orientation: 'portrait' };
          const headerRowNum = annotation.length + 3;
          const columnHeader = worksheet.getRow(headerRowNum);
          const resultCol = getTargetCol(columnHeader, 'チェック結果');
          const recordResult = [];
          // 6行目からDB保存
          const startRow = headerRowNum + 1;
          const targetRowCnt = worksheet.rowCount + 1 - startRow;
          // 今月の申請回数が4回を上回っていないか確認
          if (monthlyApplicationCount >= maxApplicationCount) {
            const actions: BtnProps[] = [
                {
                    color: "indigo",
                    children: "閉じる",
                    onClick: () => {
                        setIsOpenDialog(false);
                        initDialog();
                    }
                },
            ];
            const childText = (
                <div>
                    <p>{ConstMessage.ERR_MONTHLY_UPPER_LIMIT.replace('%1', maxApplicationCount.toString())}</p>
                </div>
            );
            setIsImport(false);
            setIsOpenDialog(true);
            setDialogTitle(fileAttached);
            setDialogChildren(childText);
            setDialogActions(actions);
            setLoadProgress(-1);
            resolve({ status: "failed", data: [] });
            return;
          }
          // 1回の申請でカード枚数が1000枚を上回っていないか確認
          if (requestLimitFlg && targetRowCnt > maxApplicationSheet) {
            const actions: BtnProps[] = [
                {
                    color: "indigo",
                    children: "閉じる",
                    onClick: () => {
                        setIsOpenDialog(false);
                        initDialog();
                    }
                },
            ];
            const childText = (
                <>
                    <div><p>{ConstMessage.IMPORT_EXCEL_FAILED_DIALOG_TEXT}</p></div>
                    <ul className={`list-disc m-2 text-green-700`}>
                        <li className={"flex"}><DocumentArrowUpIcon className={"h-6 w-6"} />{file?.name}</li>
                    </ul>
                    <div className={'text-red-500'}><p>{ConstMessage.ERR_UPPER_LIMIT.replace('%1', maxApplicationSheet.toString())}</p></div>
                </>
            );
            setIsImport(false);
            setIsOpenDialog(true);
            setDialogTitle(fileAttached);
            setDialogChildren(childText);
            setDialogActions(actions);
            setLoadProgress(-1);
            resolve({ status: "failed", data: [] });
            return;
          }
          let cardCount = targetRowCnt;
          let processRowCnt = 0;
          let rowDataList: string[] = [];
          for (let i = startRow; i < startRow + targetRowCnt; i++) {
            const row = worksheet.getRow(i);
            rowDataList.push(getCellText(row.getCell(1).value));
          };
          console.log(rowDataList);

          const startProgress = 0;
          const endProgress = 90;
          const totalRows = worksheet.rowCount + 1 - startRow;

          for (let i = startRow; i < worksheet.rowCount + 1; i++) {
            processRowCnt++;
            const row = worksheet.getRow(i);
            if (resultCol >= 0) {
              // エラーファイルの場合
              const result = getCellText(row.getCell(resultCol).value);
              if (result === "○") {
                // 読取結果が ○ の場合
                continue;
              }
            }
            const rowData = getRowData(row);
            const targetRowError = await targetRowDataCheck(rowData, file, rowDataList);
            if(rowData.userNumber == ""){
              //空行はカード数に数えない
              cardCount--;
            } else if (targetRowError?.length == undefined || targetRowError.length <= 0) {
              try {
                recordResult.push({
                  rowNumber: i,
                  status: 'success'
                });
              } catch (e) {
                // 例外発生
                recordResult.push({
                  rowNumber: i,
                  status: 'error',
                  message: e
                });
              }
            } else {
              // 処理行のデータにエラーがある場合
              recordResult.push({
                rowNumber: i,
                status: 'failed',
                info: targetRowError
              });
            }
            if ((i - startRow) % 10 === 0) {
              const ratio = (i - startRow) / totalRows;
              const progress = startProgress + ratio * (endProgress - startProgress);
              setLoadProgress(Math.floor(progress));
            }
          };
          setLoadProgress(90);
          if (recordResult.filter((item) => item.status !== "success").length > 0) {
            // アップロードできないデータが1件以上存在する場合
            resolve({ status: "failed", data: recordResult });
          } else {
            // すべてインポートできた場合
            resolve({ status: "success", data: recordResult });
            
            //添付ファイルを一覧に追加
            const dispExcelFileName = file?.name;
            const excelFileName = `${dispExcelFileName?.replace(".xlsx","")}${convertDateSecToStringCompactFormat(new Date)}.xlsx`;
            const excelFilePath = "inPut/idCardXLSX/" + tenantId + "/" + getCurrentMonth() + "/";
            const UserCardCreateState: UserCardCreateState = {
              id: "",
              tenantId: tenantId!,
              status: "waitRequest",
              attachmentAt: new Date(),
              createCount: cardCount,
              createAt: null,
              excelFileName: excelFileName,
              excelFilePath: excelFilePath,
              dispExcelFileName: dispExcelFileName,
              pdfFileName: "",
              pdfFilePath: "",
              createUserUid: "",
              requestAt: null,
              errorUserMaps: [],
              requestUserUid: currentUser?.uid!,
            }
            await systemParametersQuery.addUserCardCreateState(UserCardCreateState);
            //FireStoreにExcelファイルを追加
            if(file != null){
              const blob = file;
              const storageRef = ref(appStorage, `${excelFilePath}${excelFileName}`);
              const newBlob = new Blob([blob]);
              await uploadBytes(storageRef, newBlob);
            }
            setUpdateFlg(!updateFlg);
          }
          setLoadProgress(100);
        } catch (e: any) {
          console.error(e);
          dispatch(alertOpen(AlertValue(e.toString(), "danger")));
          setLoadProgress(-1);
          resolve({ status: "error", data: e })
        }
      };
      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);
    });
    return promise;
  };

  //処理行のデータを返す
  const getRowData = (row: ExcelJS.Row) => {
    const userNumber = getCellText(row.getCell("userNumber").value) != "-" ? getCellText(row.getCell("userNumber").value) : "";
    return {
      userNumber: userNumber,
    }
  };

  let rowDataCount = 1;
    // 処理行のデータにエラーがないか確認を行う
  const targetRowDataCheck = async (rowData: any, file: File | null, rowDataList: string[]) => {
    const targetRowError = [];
    const invalidValueErr = [];
    const user = await userQuery.getUserData(currentUser?.tenantId!, company.displayId + rowData.userNumber);
    rowDataCount++;
    //Excel入力内容チェック
    if (rowData.userNumber != undefined && rowData.userNumber != "") {
      let errorList : string[] = [];
      let overlapFlg = false;
      let overlapCount = 0;
      //添付ファイル内の番号重複確認
      for(let i = 0; i< rowDataList.length; i++){
        if(rowDataList[i] == rowData.userNumber){
          overlapCount++;
        }
      }
      if(overlapCount >= 2){
        overlapFlg = true;
      }
      if (user && user.id == company.displayId + rowData.userNumber) {
        if(user.accountSuspensionFlg == true){
          //アカウント利用停止
          errorList.push('userAccountErr');
        }else if (user.lastName == "" || user.lastName == undefined) {
          //利用者名の登録なし
          errorList.push('userNameErr');
        } else {
          //利用者名登録あり、エラーなし
          errorList.push('noErr');
        }
      }
      if(user && errorList.length == 1 && errorList[0] == 'noErr' && overlapFlg == false){
        //利用者番号にエラーがないとき
        //何もしない
      } else {
        //エラーあるとき
        invalidValueErr.push(getErrorDataItem('userNumber'));
      }
      if (invalidValueErr.length > 0) {
        console.log(errorList);
        if (errorList.length == 0) {
          targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_INVALID_USER_NUMBER, invalidValueErr));
        } else if (overlapFlg == true){
          //重複している利用者番号があるとき
          targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_OVERLAP_USER_NUMBER, invalidValueErr));
        } 
        if (errorList.includes('userAccountErr')) {
          targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_USER_ACCOUNT, invalidValueErr));
        }
        if (errorList.includes('userNameErr')) {
          targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_NOT_FOUND_USER_NAME, invalidValueErr));
        }
        return targetRowError;
      }
    } else {
      //利用者番号の入力がない行
      //何もしない
    }
  }

  // エラーファイルのダウンロード
  const downloadErrorFile = () => {
    const fileURL = window.URL.createObjectURL(targetFile as Blob);
    setTargetFile(undefined);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      setLoadProgress((0));
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try {
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          worksheet.pageSetup = { orientation: 'portrait' };
          const columnRowNum = annotation.length + 3;
          const columnHeader = worksheet.getRow(columnRowNum);
          const endCol = getTargetCol(columnHeader, column[0].header);
          const resultCol = endCol + 1;
          const errorInfoCol = endCol + 2;
          if (getTargetCol(columnHeader, 'チェック結果') < 0) {
            worksheet.getRow(annotation.length + 3).getCell(resultCol).value = 'チェック結果';
            worksheet.getRow(annotation.length + 3).getCell(errorInfoCol).value = 'エラー内容';
          }
          const defaultStyle = worksheet.getCell('A1').style;
          const startRow = columnRowNum + 1;
          for (let i = startRow; i < worksheet.rowCount + 1; i++) {
            const row = worksheet.getRow(i);
            const targetDataInfo = fileDataInfo.filter((data) => data.rowNumber === i)[0];
            // インポート対象データの場合
            if (targetDataInfo !== undefined) {
              if (targetDataInfo.status === "success") {
                // 登録成功データ
                row.getCell(1).style.fill = undefined;
                row.getCell(resultCol).value = "○";
                row.getCell(errorInfoCol).value = "";
              } else if (targetDataInfo.status === "failed") {
                // 登録失敗データ
                const cellStyle = row.getCell(1).style;
                if (cellStyle.numFmt != undefined) {
                  const cellStyle = row.getCell(1).style.numFmt;
                  row.getCell(1).style = Object.create(defaultStyle);
                  row.getCell(1).style.numFmt = cellStyle;
                } else {
                  row.getCell(1).style = Object.create(defaultStyle);
                }
                const infoStr: string[] = [];
                targetDataInfo.info.forEach((items: any) => {
                  items.data.forEach((item: any) => {
                    item.colNo.forEach((col: any) => {
                      row.getCell(col).style.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFCCFF' },
                      }
                    });
                  });
                  infoStr.push(items.message);
                });
                row.getCell(resultCol).value = "×";
                row.getCell(errorInfoCol).value = infoStr.join('／');
              } else if (targetDataInfo.status === "error") {
                // 処理中にエラーが発生したデータ
                const infoStr: string[] = [];
                row.getCell(resultCol).value = "×";
                row.getCell(errorInfoCol).value = infoStr.join('／');
              }
            }
            setProgress((i - startRow) / (worksheet.rowCount + 1 - startRow) * 100)
          }

          // ダウンロードリンク
          const a = document.createElement("a");
          // BOM
          const bom = "\uFEFF";
          const uint8Array = await workbook.xlsx.writeBuffer();
          const blob = new Blob([uint8Array], { type: "application/octet-binary" });
          a.href = window.URL.createObjectURL(blob);

          // エラーファイルの先頭に付与する文字列を取得
          const fileNamePrefix = getImportErrorFileNamePrefix(targetFile?.name);
          a.download = `${fileNamePrefix}利用者IDカード_${company?.name}_${convertDateTimeToStringCompactFormat(new Date())}.xlsx`;
          a.click();
          a.remove();
          const date = new Date();
          resolve(null);
        } catch (e: any) {
          console.error(e);
          dispatch(alertOpen(AlertValue(e.toString(), "danger")));
          resolve(null);
        }
      };
      xhr.responseType = "arraybuffer";
      xhr.open("GET", fileURL);
      xhr.send(null);
    });
    return promise;
  }

  // エラーデータを返す
  const getErrorDataItem = (name: string) => {
    return { colNo: [getColumnIndex(name)], colName: getColumnHeader(name) };
  }

  // インデックスを返す
  const getColumnIndex = (name: string) => {
    return column.findIndex((target) => target.key === name) + 1;
  }

  // カラム名を返す
  const getColumnHeader = (name: string) => {
    return column.find((target) => target.key === name)?.header;
  }

  // エラーデータセット
  const getErrorData = (errMessage: string, errArr: any[]) => {
    return {
      message: errMessage,
      data: errArr
    };
  }

  // 汎用ダイアログ用
  // toggleDialog
  // initDialog
  const toggleDialog = () => {
    setIsOpenDialog(isOpenDialog);
  };
  const initDialog = () => {
    setDialogTitle("");
    setDialogChildren("");
    setDialogActions([]);
  };

  //削除
  const onDelete = async(id: string) => {
    try {
      setIsLoad(true);
      deleteDialogToggle();
      await systemParametersQuery.deleteUserCardCreateState(id);
      const excelFilePath = "inPut/idCardXLSX/" + tenantId + "/" + getCurrentMonth() + "/";
      const desertRef = ref(appStorage,  `${excelFilePath}${selectFile?.excelFileName}`);
      await deleteObject(desertRef).then(() => {
        // Storageデータ削除完了
      })
    } catch (err: any) {
      let errorMessage = err.code;
      if (errorMessage === "ERR_NETWORK") {
        dispatch(alertOpen(AlertValue("ネットワークに接続できません。", "danger")));
      } else {
        dispatch(alertOpen(AlertValue("保存に失敗しました。", "danger")));
      }
      console.error(err);
    }
    dispatch(alertOpen(AlertValue("削除しました。", "success")));
    setUpdateFlg(!updateFlg);
  }

  //申請
  const onApplication = async(item: UserCardCreateState) => {
    try {
      ApplicationDialogToggle();
      item.status = 'standBy';
      item.requestAt = new Date();
      await systemParametersQuery.updateUserCardCreateState(item);
      // メール送信
      try{
      sendPDFCreateMail(item);
    }catch(e: any){
      console.error(e);
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_UPDATE_DATA, "danger")));
    }
      //申請完了モーダル表示
      const dialogChildren = (<>
        申請が完了しました。
      </>)
      const actions: BtnProps[] = [
        {
          color: "indigo",
          children: "閉じる",
          onClick: () => {
            setIsOpenDialog(false);
          }
        },
      ];
      setIsOpenDialog(true);
      setDialogTitle("申請");
      setDialogChildren(dialogChildren);
      setDialogActions(actions);
      setUpdateFlg(!updateFlg);
    } catch (err: any) {
      let errorMessage = err.code;
      if (errorMessage === "ERR_NETWORK") {
        dispatch(alertOpen(AlertValue("ネットワークに接続できません。", "danger")));
      } else {
        dispatch(alertOpen(AlertValue("申請に失敗しました。", "danger")));
      }
      console.error(err);
    }
  }

  // 申請メール送信処理
  const sendPDFCreateMail = async (item: UserCardCreateState) => {
    try{
      let successFlg = false;
      // 運営者宛
      const text = appliedMail(item);
      const subject = `イベントサポートシステム 団体管理システム 利用者IDカード発行申請依頼`;
      const result = await authApi.requestAllAdminSendEmail(text, subject);
      // 団体宛
      const text2 = appliedMailToTenant(item, currentUser?.displayName ?? "");
      const subject2 = `イベントサポートシステム 団体管理システム 利用者IDカード発行申請完了`;
      const toAddress2 = currentUser?.email ?? "";
      const result2 = await authApi.requestSendEmailGeneral(text2, subject2, toAddress2);
      if(result.success && result2.success){
        successFlg = true;
      }
      if(!successFlg){
        console.error(result);
        console.error(result2);
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_SEND_MAIL, "danger")));
      }
    }catch(err: any){
      console.error(err)
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_SEND_MAIL, "danger")));
    }
  }

  // 申請完了用メール本文(運営宛)
  const appliedMail = (item: UserCardCreateState) => {
    const lineBreak = "<br>";
    const body = 
      `運営者様${lineBreak}${lineBreak}利用者IDカード発行申請の依頼を受け付けました。${lineBreak}　団体名：${lineBreak}　　${company.name}${lineBreak}　申請書ファイル名：${lineBreak}　　${item.dispExcelFileName}${lineBreak}　申請日時：${lineBreak}　　${item.requestAt ? convertDateTimeToJapaneseString(item.requestAt) : ""}${lineBreak}${lineBreak}　管理画面で依頼情報を確認し、PDF出力を行ってください。`;
    return body;
  }

  // 申請完了用メール本文(団体宛)
  const appliedMailToTenant = (item: UserCardCreateState, toName: string | null) => {
    const lineBreak = "<br>";
    const body = 
      `${company.name}　${toName !== null && toName !== "" ? toName : "管理者"} 様${lineBreak}${lineBreak}利用者IDカード発行申請が完了しました。${lineBreak}　申請書ファイル名：${lineBreak}　　${item.dispExcelFileName}${lineBreak}　申請日時：${lineBreak}　　${item.requestAt ? convertDateTimeToJapaneseString(item.requestAt) : ""}${lineBreak}${lineBreak}　申請から利用者IDカードがダウンロード可能になるまで５営業日ほどかかります。${lineBreak}　利用者IDカードのダウンロードが可能になりましたらメールでお知らせします。`
    return body;
  }

  // PDFダウンロード
  const onDownloadPDF = async (item: UserCardCreateState) => {
    const pdfFileName = item.pdfFileName;
    const pdfFilePath = item.pdfFilePath;
    try {
      const pdfRef = ref(appStorage, `${pdfFilePath}${pdfFileName}`);
      const downloadUrl = await getDownloadURL(pdfRef);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link)
      dispatch(alertOpen(AlertValue("ダウンロードに成功しました。", "success")));
      link.click();
      document.body.removeChild(link)
      URL.revokeObjectURL(downloadUrl);
    } catch (err: any) {
      console.log(err);
      dispatch(alertOpen(AlertValue("ダウンロードに失敗しました。", "danger")));
    }
  }
  
  return (
    <div className="h-full">
      <Progress
        open={loadProgress >= 0 && loadProgress < 100}
        progressNum={loadProgress}
        color={"green"}
      />
      {/* 依頼方法 */}
      <RequestMethodModal
        children={undefined}
        open={isOpen}
        toggle={toggle}
        closeOnClickOutside={false}
        maxApplicationCount={maxApplicationCount}
        maxApplicationSheet={maxApplicationSheet}
      />
      <ModalAndAlmightyDialog
        toggle={toggleDialog}
        open={isOpenDialog}
        title={dialogTitle}
        children={dialogChildren}
        actions={dialogActions}
        height={"72"}
        closeOnClickOutside={false}
      />
      {/* 削除 */}
      <UserIdcardFileDeleteModal
        children={undefined}
        open={deleteDialogIsOpen}
        toggle={deleteDialogToggle}
        closeOnClickOutside={false}
        userCardCreateState={selectFile}
        handle={onDelete}
      />
      {/* 申請 */}
      <UserIdcardFileApplicationModal
        children={undefined}
        open={applicationDialogIsOpen}
        toggle={ApplicationDialogToggle}
        closeOnClickOutside={false}
        userCardCreateState={applicationFile}
        handle={onApplication}
        monthlyApplicationCount={monthlyApplicationCount}
        maxApplicationCount={maxApplicationCount}
      />
      {/* 申請(申請回数、カード枚数が上限) */}
      <MaxApplicationCountModal
        children={undefined}
        open={maxApplicationCountIsOpen}
        toggle={MaxApplicationCountToggle}
        closeOnClickOutside={false}
        maxApplicationCount={maxApplicationCount}
      />
      {/* 詳細 */}
      <UserIdCardErrorInfoModal
        open={isOpenErrorInfoDialog}
        toggle={toggleErrorInfoDialog}
        closeOnClickOutside={true}
        children={undefined}
        col={userIdCardErrorCol}
        row={userIdCardErrorRow}
        pdfFlg={detailFlg}
      />

      <div className="flex px-6 pt-6 pb-0 sm:items-center">
        <div className="flex items flex-auto space-x-4">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            利用者IDカード出力
          </h2>
          <div>
            <h3 className="flex items-end">
              今月の申請回数：{monthlyApplicationCount}
              <span className="ml-1 text-red-500">
                （1ヵ月の申請回数上限：{maxApplicationCount}回）
              </span>
            </h3>
          </div>
        </div>
        <Button
          size={"sm"}
          className={"mr-2 h-8"}
          outline
          onClick={async () => {
            if (await checkOption("userIdCard", dispatch)) {
              toggle();
              }
            }
          }
          children={"依頼方法"}
        />
      </div>
      <div className="px-7">
        <div className="flex h-12 items-center" style={{width:500}}>
          <Button
            size={"sm"}
            className={"h-8 ml-5 items-center"}
            onClick={async () => {
              if (await checkOption("userIdCard", dispatch)) {
                onAplicationFileDownload();
              }
            }}
            children={"申請書ダウンロード"}
          />
        
          <Button
            size={"sm"}
            className={"h-8 ml-5 items-center"}
            onClick={async () => {
              if (await checkOption("userIdCard", dispatch)) {
                fileInputRef.current?.click(); // ファイル選択ダイアログを開く
              }
            }}
            children={fileAttached}
          />

          <input
            type="file"
            ref={fileInputRef}
            hidden
            accept=".xlsx"
            onChange={(e) => {
              const files = e.target.files;
              if (files && files[0]) {
                setTargetFile(files[0]);
                onImport("xlsx", files[0], e);
              }
            }}
          />
        </div>
      </div>
      {isLoad ? <Spiner /> : (
        <>
          <div className={"px-6"}>
            <TableList
              header
              gridCol={columns}
              gridRow={rowList}
              limit={50}
            />
          </div>
        </>
      )}

    </div>
  );
};